import { render, staticRenderFns } from "./TableNotInUse.vue?vue&type=template&id=641a3e29&scoped=true&"
import script from "./TableNotInUse.vue?vue&type=script&lang=js&"
export * from "./TableNotInUse.vue?vue&type=script&lang=js&"
import style0 from "./TableNotInUse.vue?vue&type=style&index=0&id=641a3e29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a3e29",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VChip,VIcon,VList,VListItem,VListItemTitle,VMenu,VSubheader})
